import React, { createContext, useState, useContext } from 'react';
 
interface BundleItemSelectionKeyType {
  bundleItemSelectedKey: string[][];
  resetBundleItemSelectedKey: () => void;
  addRow: () => void;
  addbundleItemSelectedKey: (newRow: string[]) => void;
  replaceBundleItemSelectedKey: (index: number, newRow: string[]) => void;
}

const BundleItemSelectedKeyContext = createContext<BundleItemSelectionKeyType | undefined>(undefined);

export const BundleItemSelectedKeyProvider: React.FC = ({ children }) => {
  const [bundleItemSelectedKey, setbundleItemSelectedKey] = useState<string[][]>([]);
  const resetBundleItemSelectedKey = () => setbundleItemSelectedKey([]);
  const addRow = () => setbundleItemSelectedKey((prev) => [...prev, []]);
  const addbundleItemSelectedKey = (newRow: string[]) => {
    setbundleItemSelectedKey((prev) => [...prev, newRow]);
  };

  const replaceBundleItemSelectedKey = (index: number, newRow: string[]) => {
        setbundleItemSelectedKey((prev) => {
          const updatedArray = [...prev];
          if (index >= 0 && index < updatedArray.length) {
            updatedArray[index] = newRow; // Replace the row at the given index
          }
          return updatedArray;
        });
      };
    
  const value: BundleItemSelectionKeyType = {
    bundleItemSelectedKey,
    resetBundleItemSelectedKey,
    addRow,
    addbundleItemSelectedKey,
    replaceBundleItemSelectedKey
  };

  return (
    <BundleItemSelectedKeyContext.Provider value={value}>
      {children}
    </BundleItemSelectedKeyContext.Provider>
  );
};
 
export const useBundleItemSelectedKey = (): BundleItemSelectionKeyType => {
  const context = useContext(BundleItemSelectedKeyContext);
  if (!context) {
    throw new Error('useBundleItemSelectedKey must be used within a BundleItemSelectedKeyProvider');
  }
  return context;
};
